import { useEffect, useMemo, useCallback, useState } from 'react';
import { BroadcastChannel } from 'broadcast-channel';
import { useRouter } from 'next/router';

const useLoginBroadcast = ({ eventId = '', eventName = '' } = {}) => {
  const router = useRouter();
  const [loggedInEvent, setLoggedInEvent] = useState({
    id: eventId,
    name: eventName
  });

  // Setup BroadcastChannel to listen for other windows/tabs logging in
  const channel = useMemo(() => {
    if (typeof window !== 'undefined') {
      return new BroadcastChannel('event');
    }
  }, []);

  /**
   * Update our internal state when we receive a message on the broadcast channel
   * telling us that a page has loaded using a different eventId than the event
   * we're viewing in the current browser tab.
   */
  const onMessage = useCallback(
    ({ eventId: id, eventName: name }) => {
      if (id !== router.query.eventId) {
        setLoggedInEvent({ id, name });
      }
    },
    [router]
  );

  // Setup event handlers
  useEffect(() => {
    channel.addEventListener('message', onMessage);
    return () => {
      channel.removeEventListener('message', onMessage);
    };
  }, [channel, onMessage]);

  useEffect(() => {
    if (eventId && eventName) {
      setLoggedInEvent({ id: eventId, name: eventName });
      channel.postMessage({ eventId, eventName });
    }
  }, [eventId, eventName]); // eslint-disable-line react-hooks/exhaustive-deps

  return loggedInEvent;
};

export default useLoginBroadcast;
